import React, { useState, useEffect, useMemo, useRef } from 'react'
import { Box, Modal } from '@mui/material'
import HeavyTable from '../components/table/HeavyTable'
// import { useSelector } from 'react-redux'
import {
    makeSureIsArray, makeOptions, resetAll,
    changeViewOptions, changeRowsPerPage, changeFiltered, changeSearch, loadData, cancelAction
} from '../functions/general'
import { showWarningSwal } from '../functions/alert'
import { getDifficultyGroup } from '../functions/getData'
import { deleteDifficultyGroup } from '../functions/deleteData'
import { showNotification } from '../functions/snackbar'
import AddDifficultyGroupModal from '../components/DifficultyGroup/AddDifficultyGroupModal'
import EditDifficultyGroupModal from '../components/DifficultyGroup/EditDifficultyGroupModal'
import DeleteModal from '../components/modal/DeleteModal'
import ReusableButton from '../components/general/ReusableButton'
import LoadingBackdrop from '../components/general/LoadingBackdrop'
import NoData from '../components/general/NoData'
import Loader from '../components/general/Loader'
import { useSnackbar } from 'notistack'
import PageHeader from '../components/ui/PageHeader'
import TableCard from '../components/ui/TableCard'
import TableToolbar from '../components/ui/TableToolbar'
import SearchInput from '../components/ui/SearchInput'
import { useLegacyFilters } from '../components/ui/useFilterDrawer'
const difficultyGroupHeader = [
    { id: 'name', label: 'Name', },
    { id: 'status', label: 'Status' },
    { id: 'difficulty', label: 'No. of Difficulty' },
    { id: 'created_at', label: 'Created By' },
    { id: 'updated_at', label: 'Updated By' }
]
const initialParams = '?limits=10'
export default function DifficultyGroup() {
    document.title = 'Difficulty Group'
    const isMounted = useRef(false)
    const [header, setHeader] = useState(difficultyGroupHeader)
    const [difficultyGroupTable, setDifficultyGroupTable] = useState()
    const [filtered, setFiltered] = useState([
        { label: 'Status', state: '', key: 'status', header: 'status' }
    ])
    const [filterOptions, setFilterOptions] = useState()
    const [viewOptions, setViewOptions] = useState([
        { label: "Created By", state: true, key: 'created_at' },
        { label: 'Updated By', state: true, key: 'updated_at' },
        { label: "Status", state: true, key: 'status' }
    ])
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [search, setSearch] = useState('')
    const [params, setParams] = useState(initialParams)
    const [loading, setLoading] = useState(false)
    const [loadingTable, setLoadingTable] = useState(false)
    const [firstLoaded, setFirstLoaded] = useState(false)
    const [id, setId] = useState('')
    const [selected, setSelected] = useState([])
    const [selecting, setSelecting] = useState([])
    const [onDelete, setOnDelete] = useState(false)
    const [onAddDifficultyGroup, setOnAddDifficultyGroup] = useState(false)
    const [onEdit, setOnEdit] = useState(false)
    const cancelDelete = () => cancelAction(setOnDelete, setId)
    const cancelEdit = () => cancelAction(setOnEdit, setId)
    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const afterFunction = (cancel, data) => {
        if ([200, 201].includes(data.status)) {
            resetAll(initialParams, filtered, setParams, setSearch, setFiltered)
            getData(initialParams, signal)
            cancel()
            showNotification('success', data.message, enqueueSnackbar, closeSnackbar)
            setSelected([])
            setSelecting([])
        }
    }
    const deleteFunction = () => {
        setLoading(true)
        deleteDifficultyGroup({ id: id === '' ? selected : [id] }).then(d => {
            afterFunction(cancelDelete, d)
        }).catch(e => console.log(e)).finally(() => isMounted.current && setLoading(false))
    }
    const getData = (params, signal) => {
        setSelected([])
        setSelecting([])
        loadData(setLoadingTable, setFirstLoaded, getDifficultyGroup, params, setDifficultyGroupTable, setFilterOptions, false, signal)
    }
    const onChangeViewOptions = value => changeViewOptions(difficultyGroupHeader, setViewOptions, setHeader, value)
    const onChangeRowsPerPage = value => {
        changeRowsPerPage(value, rowsPerPage, filtered, search, signal, setRowsPerPage, setParams, getData)
    }
    const onChangeFiltered = value => {
        changeFiltered(value, filtered, search, rowsPerPage, signal, setFiltered, setParams, getData)
    }
    const onChangeSearch = value => {
        changeSearch(value, search, filtered, rowsPerPage, signal, setSearch, setParams, getData)
    }
    const onChangePage = pageNo => getData(`${params}&page=${pageNo}`, signal)
    const controller = useMemo(() => new AbortController(), [])
    const signal = controller.signal
    useEffect(() => {
        isMounted.current = true
        getData(initialParams, signal)
        return () => {
            controller.abort()
            isMounted.current = false
        }
    }, [controller, signal])
    const onClickMassDelete = () => {
        return selected.length ? setOnDelete(true) : showWarningSwal('Please select at least one difficulty group to mass delete')
    }
    const legacyFilters = useLegacyFilters({
        filtered,
        filterOptions: filterOptions && filtered.map(f => makeOptions(filterOptions, f.header)),
        onChangeFiltered,
    })
    const total = difficultyGroupTable?.total ?? difficultyGroupTable?.meta?.total
    return (
        <Box className='wrapperBox simcc-page'>
            <LoadingBackdrop loading={loading} />
            <PageHeader
                title='Difficulty Groups'
                actions={
                    <>
                        <>
                            <ReusableButton variant="primary" text='Add Difficulty Group' onClick={() => setOnAddDifficultyGroup(true)} iconType='add' />
                            <ReusableButton variant="danger" text='Mass Delete' onClick={() => onClickMassDelete()} iconType='delete' />
                        </>
                    </>
                }
            />
            <TableCard
                toolbar={
                    <TableToolbar
                        search={<SearchInput state={search} setState={onChangeSearch} placeholder="Search name" ariaLabel={"Search only in \"Name\" column"} />}
                        onOpenFilters={filterOptions ? legacyFilters.openDrawer : undefined}
                        filtersOpen={legacyFilters.isOpen}
                        filterCount={legacyFilters.count}
                        meta={total !== undefined && `${Number(total).toLocaleString()} difficulty groups`}
                    />
                }
                chips={legacyFilters.chips}
            >
                {loadingTable && <Loader height={600} />}
                {!loadingTable && difficultyGroupTable && makeSureIsArray(difficultyGroupTable.data).length && <HeavyTable bare onChangeRowsPerPage={onChangeRowsPerPage}
                    headers={header} list={difficultyGroupTable} title='difficulty' rowsPerPage={rowsPerPage}
                    setOnDelete={setOnDelete} onChangePage={onChangePage} fixed={['name']}
                    selecting={selecting} setSelecting={setSelecting} selected={selected} setSelected={setSelected}
                    setRowsPerPage={setRowsPerPage} setId={setId} setOnEdit={setOnEdit}
                />}
                {!loadingTable && firstLoaded && difficultyGroupTable && !makeSureIsArray(difficultyGroupTable.data).length && <NoData height={600} />}
            </TableCard>
            {legacyFilters.drawer}
            <Modal open={onAddDifficultyGroup} onClose={() => setOnAddDifficultyGroup(false)}>
                <>
                    <AddDifficultyGroupModal setLoading={setLoading} setOnAddDifficultyGroup={setOnAddDifficultyGroup}
                        afterAddingDifficultyGroup={afterFunction} />
                </>
            </Modal>
            <Modal open={onEdit} onClose={() => cancelEdit()}>
                <>
                    {difficultyGroupTable && <EditDifficultyGroupModal setLoading={setLoading} table={difficultyGroupTable} id={id}
                        afterEditingDifficultyGroup={afterFunction} cancelEdit={cancelEdit} />}
                </>
            </Modal>
            {/* {JSON.stringify({ params, loading, firstLoaded, selecting, onDelete, header, difficultyGroupTable })} */}
            <Modal open={onDelete} onClose={() => cancelDelete()}>
                <>
                    {Boolean(difficultyGroupTable) && <DeleteModal table={difficultyGroupTable} id={id} selected={selected}
                        deleteFunction={deleteFunction} cancelDelete={cancelDelete} />}
                </>
            </Modal>
        </Box >
    )
}